import styles from "./MarketPlaceDetail.module.css";
import { Check } from "@material-ui/icons";
import UnitPriceForm from "../MarketPlacePricing/UnitPriceForm";
import { isDefaultRow } from "../../../utils/unitPrice";

function MarketPlaceT1({
  selected,
  selectInterval,
  plans,
  setPlans,
  features,
  selectedVendor,
}) {
  const updatePlanUnitIds = (planId, unitIdsArray) => {
    setPlans((prev) =>
      prev.map((plan) => {
        if (plan.id !== planId) return plan;
        const updateMap = new Map(unitIdsArray.map((u) => [u.id, u]));
        return {
          ...plan,
          unit_ids: plan.unit_ids.map((unit) =>
            updateMap.has(unit.id)
              ? { ...unit, ...updateMap.get(unit.id) }
              : unit,
          ),
        };
      }),
    );
  };

  return (
    <>
      <div className={styles.T1Container}>
        <div className={styles.heading}>Product price</div>
        <div className={styles.horizontalForm}>
          {/* dummy blank card  */}
          <div className={styles.AddCardForm}></div>
          {plans.length > 0 &&
            plans
              .filter(
                (item, id) =>
                  item.typeId === selected && item.interval === selectInterval,
              )
              .map((product, index) => {
                const filteredUnitIds =
                  product.unit_ids?.filter(
                    (u) => u.vendor_id === selectedVendor,
                  ) || [];
                return (
                  <>
                    {/* price prices */}
                    {(product.price_type === "price" ||
                      !product.price_type) && (
                      <div key={product.id} className={styles.pricing_card}>
                        <div className={styles.pricing_card_circle_top_left} />
                        <div
                          className={styles.pricing_card_circle_bottom_right}
                        />
                        {/* Name */}
                        <div className={styles.pricing_card_title}>
                          <p>{product.name}</p>
                        </div>
                        {/* Description */}
                        <div className={styles.pricing_card_description}>
                          <p>{product.description || "—"}</p>
                        </div>
                        {/* Payment */}
                        <div className={styles.paymentRow}>
                          <div className={styles.AmountField}>
                            <input
                              type="text"
                              name="unit_ids"
                              value={
                                (filteredUnitIds.find(isDefaultRow) ??
                                  filteredUnitIds[0])?.Marketplace_price ?? "0"
                              }
                              className={styles.amountInput}
                              placeholder="Enter Amount here"
                              readOnly
                            />
                            <UnitPriceForm
                              key={product.id}
                              unitPrices={filteredUnitIds || []}
                              onSave={(updatedUnitPrices) => {
                                updatePlanUnitIds(
                                  product.id,
                                  updatedUnitPrices,
                                );
                              }}
                            />
                          </div>
                          <div className={styles.paymentSelect}>
                            {product.currency}
                          </div>
                        </div>
                        {/* Tags */}
                        <div className={styles.pricing_card_subtext}>
                          {product.tags || "—"}
                        </div>
                        {/* Status & Region */}
                        <div className={styles.pricing_card_notes}>
                          <div className={styles.pricing_card_note}>
                            {product.status}
                          </div>
                          <div className={styles.pricing_card_note}>
                            <span>{product.region || "—"}</span>
                          </div>
                        </div>
                        {/* Trial & Modify Orders */}
                        <div className={styles.pricing_card_notes}>
                          <div className={styles.pricing_card_note}>
                            {product.trial_period_days
                              ? `${product.trial_period_days} days trial`
                              : "No Trial"}
                          </div>
                          <div className={styles.pricing_card_note}>
                            {product.modify_orders || "—"}
                          </div>
                        </div>
                        {/* unit_price type */}
                        <div className={styles.pricing_card_note}>
                          {product.unit_price_type || "—"}
                        </div>
                        {/* Price validity */}
                        <div className={styles.pricing_card_notes}>
                          <div className={styles.pricing_card_note}>
                            <p>
                              {product.price_validity_interval === "lifetime"
                                ? "No Expiry"
                                : `${product.n_price_validity_interval} ${product.price_validity_interval}(s)`}
                            </p>
                          </div>
                        </div>
                        {/* GST */}
                        <div className={styles.pricing_card_gst}>
                          GST extra applicable for INR pricing
                        </div>
                        <p className={styles.pricing_card_divider}></p>
                        {/* Highlights */}
                        <div className={styles.pricing_card_highlights_title}>
                          <p>Plan highlights</p>
                        </div>
                        <ul className={styles.pricing_card_features}>
                          {product.plan_highlight.map((highlight, index) => (
                            <li
                              key={index}
                              className={styles.pricing_card_feature_item}
                            >
                              <Check style={{ fontSize: "14px" }} />
                              {highlight}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {/* contact prices */}
                    {product.price_type === "contact" && (
                      <form key={product.id} className={styles.pricing_card}>
                        <div className={styles.pricing_card_circle_top_left} />
                        <div
                          className={styles.pricing_card_circle_bottom_right}
                        />
                        {/* Name */}
                        <div className={styles.pricing_card_title}>
                          <p>{product.name}</p>
                        </div>

                        {/* Description */}
                        <div className={styles.pricing_card_description}>
                          <p>{product.description || "—"}</p>
                        </div>

                        {/* Payment */}
                        <div className={styles.paymentRow}>
                          <div className={styles.AmountField}>
                            <input
                              type="text"
                              name="unit_ids"
                              value={
                                (product.unit_ids.find(isDefaultRow) ??
                                  product.unit_ids[0])?.Marketplace_price ?? "0"
                              }
                              className={styles.amountInput}
                              placeholder="Enter Amount here"
                              readOnly
                            />
                            <UnitPriceForm
                              key={product.id}
                              unitPrices={product.unit_ids || []}
                            />
                          </div>
                          <div className={styles.paymentSelect}>
                            {product.currency}
                          </div>
                        </div>

                        {/* Tags */}
                        <div className={styles.pricing_card_subtext}>
                          {product.tags || "—"}
                        </div>

                        {/* Status & Region */}
                        <div className={styles.pricing_card_notes}>
                          <div className={styles.pricing_card_note}>
                            {product.status}
                          </div>
                          <div className={styles.pricing_card_note}>
                            <span>{product.region || "—"}</span>
                          </div>
                        </div>
                        {/* Trial & Modify Orders */}
                        <div className={styles.pricing_card_notes}>
                          <div className={styles.pricing_card_note}>
                            {product.trial_period_days
                              ? `${product.trial_period_days} days trial`
                              : "No Trial"}
                          </div>
                          <div className={styles.pricing_card_note}>
                            {product.modify_orders || "—"}
                          </div>
                        </div>
                        {/* Price validity */}
                        <div className={styles.pricing_card_notes}>
                          <div className={styles.pricing_card_note}>
                            <p>
                              {product.price_validity_interval === "lifetime"
                                ? "No Expiry"
                                : `${product.n_price_validity_interval} ${product.price_validity_interval}(s)`}
                            </p>
                          </div>
                        </div>
                        {/* GST */}
                        <div className={styles.pricing_card_gst}>
                          GST extra applicable for INR pricing
                        </div>
                        <p className={styles.pricing_card_divider}></p>
                        {/* Highlights */}
                        <div className={styles.pricing_card_highlights_title}>
                          <p>Plan highlights</p>
                        </div>
                        <ul className={styles.pricing_card_features}>
                          {product.plan_highlight.map((highlight, index) => (
                            <li
                              key={index}
                              className={styles.pricing_card_feature_item}
                            >
                              <Check style={{ fontSize: "14px" }} />
                              {highlight}
                            </li>
                          ))}
                        </ul>
                      </form>
                    )}
                  </>
                );
              })}
        </div>
        <div className={styles.heading}>Features</div>
        <div className={styles.featuresGrid}>
          {features?.length > 0 &&
            features.map((feature, i) => (
              <div key={i} className={styles.featureCard}>
                <div style={{ width: "100%" }}>
                  {/* Feature Heading */}
                  <div className={styles.featureHeader}>
                    <div className={styles.inputHeading}>
                      {feature.name || "—"}
                    </div>
                  </div>
                </div>

                <div className={styles.rows}>
                  <div className={styles.rowContainer}>
                    {feature.data.map((d, j) => (
                      <div key={j} className={styles.row}>
                        {/* Feature Title */}
                        <div className={styles.inputtitle}>{d || "—"}</div>

                        {/* Plan Values */}
                        {plans.length > 0 &&
                          plans
                            .filter(
                              (item) =>
                                item.typeId === selected &&
                                item.interval === selectInterval,
                            )
                            .map((p) => {
                              const planFeature = p.features.find(
                                (pf) => pf.key === feature.key,
                              );
                              return (
                                <div key={p.id}>
                                  <div className={styles.input}>
                                    {planFeature?.data?.[j] || "—"}
                                  </div>
                                </div>
                              );
                            })}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default MarketPlaceT1;
